import { ReadOnlyRuleBlock } from 'modules/journey/components/RuleBuilder/RuleBlock/ReadOnlyRuleBlock';
import { useRuleBuilder } from 'modules/journey/components/RuleBuilder/hooks/useRuleBuilder';
import { useSendActivityForWorkflows } from 'modules/workflowIndex/hooks/useSendActivityForWorkflows';
import { selectSendActivity } from 'modules/workflowIndex/selectors';
import { getWorkflow } from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const StyledReadOnlyHoldRules = styled.ul`
  padding-left: 0;
`;

export const ReadOnlyHoldRules = () => {
  const { state } = useRuleBuilder();
  const { rules } = state;
  const workflow = useSelector(getWorkflow);
  const exitRuleExitsByNode = useSelector(selectSendActivity(workflow.id))?.exitRuleExitsByNode;

  useSendActivityForWorkflows([{ id: workflow.id, workflowType: workflow.workflowType }]);

  if (exitRuleExitsByNode === undefined) return null; // no exit rule stats for this rule
  return (
    <StyledReadOnlyHoldRules>
      {rules.map((rule, idx) => {
        return (
          rule.id && (
            <li key={rule?.id ? `r${rule.id}` : `i${idx}`}>
              <ReadOnlyRuleBlock
                rule={rule}
                ruleIdx={idx}
                canDelete={rules.length > 1}
                isMaxOneRule
              />
            </li>
          )
        );
      })}
    </StyledReadOnlyHoldRules>
  );
};
